import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';

import ManualBookingForm from '../../../components/ManualBooking/ManualBookingForm/ManualBookingForm';
import Link from '../../../components/Link/Link';
import BookingDetails from '../../../components/ManualBooking/BookingDetails/BookingDetails';
import DescriptionModal from '../../../components/DescriptionModal/DescriptionModal';

import messages from '../../../locale/messages';
import getActiveCategories from '../addSubCategory/getActiveCategories.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import bt from '../../../components/commonStyle.css';
import s from './CreateBooking.css';

export class CreateBooking extends Component {

    render() {
        const { categories: { getActiveCategories } } = this.props;
        const { formatMessage } = this.props.intl;
        let manualBookingValues = {}
        manualBookingValues['isRandomProviderSelection'] = true;
        manualBookingValues['orderData'] = [];

        return (
            <div>
                <div className='addPageHeadingFlexContainer siteAdminPrimaryHeading'>
                    {formatMessage(messages.addNewBooking)}
                    <Link to={'/siteadmin/manual-bookings'} className={cx(bt.btnSecondary, s.displayInlineBlock)} >{formatMessage(messages.goBack)}</Link>
                </div>
                <div className='addPageDetailsGridContainer'>
                    <div>
                        <ManualBookingForm categories={getActiveCategories} initialValues={manualBookingValues} />
                    </div>
                    <div className='commonMapContainer'><BookingDetails /></div>
                </div>
                <DescriptionModal />
            </div>
        );
    }
}


export default compose(injectIntl, withStyles(bt, s),
    withQuery(getActiveCategories, {
        name: 'categories',
        options: {
            ssr: false,
            fetchPolicy: 'network-only'
        }
    })
)(CreateBooking);
